
import { repository } from 'src/jtech/jtech-repository'

export const ServiceRequestRepository = {

  nmInterfaceSigreDebitStatementForm: 'debitStatementReport.debitStatementReport',

  loadDebitStatementForm: async function () {
    return await repository.resolve(this.nmInterfaceSigreDebitStatementForm)
  }

}
